import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { dropdownOptionStyles } from './menu';

declare module '@mui/material/Autocomplete' {
  interface AutocompletePropsSizeOverrides {
    large: true;
  }
}
const autocomplete = {
  MuiAutocomplete: {
    defaultProps: {
      popupIcon: <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />,
    },
    styleOverrides: {
      root: {
        'label + & .MuiInputBase-root': {
          marginTop: '18px',
        },
        '& .MuiAutocomplete-endAdornment': {
          paddingRight: '7px',
        },
      },
      inputRoot: {
        padding: '0 10px',
        '&.MuiInputBase-adornedStart': {
          paddingLeft: '3px',
        },
      },
      clearIndicator: {
        padding: '3px',
        '& .MuiSvgIcon-root': {
          fontSize: 16,
        },
      },
      listbox: {
        '& .MuiAutocomplete-option': {
          ...dropdownOptionStyles,
        },
      },
    },
  },
};

export default autocomplete;
